/**
 * Indaleti API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LearnerPromotionDto { 
    id: number;
    learnerId: number;
    schoolId: number;
    fromAcademicYearId: number;
    fromClassId?: number | null;
    toAcademicYearId?: number | null;
    toClassId?: number | null;
    outcome: LearnerPromotionDto.OutcomeEnum;
    decidedByUserId: number;
    decidedAt: string;
    notes?: string | null;
    isReversed: boolean;
}
export namespace LearnerPromotionDto {
    export const OutcomeEnum = {
        Promoted: 'PROMOTED',
        Retained: 'RETAINED',
        Graduated: 'GRADUATED',
        Transferred: 'TRANSFERRED',
        Withdrawn: 'WITHDRAWN'
    } as const;
    export type OutcomeEnum = typeof OutcomeEnum[keyof typeof OutcomeEnum];
}


